import React, { Component } from 'react';
import Auth0Lock from 'auth0-lock';
import _auth from '../utils/authUtil';

class componentName extends Component {
    componentDidMount() {
        var lock = new Auth0Lock(
            'yIImDLdEhZ9DimhA2dDGKRC5L3IPgroK',
            'vsoauth.auth0.com',
            {
                auth: {
                    redirect: false
                },
                closable: false
                //container: "lock-login-container"
            }
        );

        // Listening for the authenticated event
        lock.on("authenticated", function(authResult) {
            // Use the token in authResult to getUserInfo() and save it to localStorage
            lock.getProfile(authResult.idToken, function(error, profile) {
                if (error) {
                // Handle error
                return;
                }
                _auth.registerSessionToken(authResult.idToken);
                // localStorage.setItem('token', authResult.idToken);
                localStorage.setItem('profile', JSON.stringify(profile));
            });
            window.setTimeout(() => {
                lock.hide();
                window.location.hash = "/";
            }, 1.75 *1000)
            
        });

        lock.show();

        let q = document.getElementsByClassName("auth0-lock-name")[0];
        q.title = "Brigde2";
        q.innerText = "Bridge2";
    }
    render() {
        return (
            <div />
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/components/Login.js